{
  "title": "Virtual Machines",
  "subtitle": "QEMU/KVM direkt — bridged Networking, VNC im Browser, Snapshots.",
  "new_vm": "Neue VM",
  "refresh": "Aktualisieren",
  "loading": "Lade…",
  "empty": "Noch keine VMs. Klicke",
  "empty_cta": "„Neue VM\"",
  "empty_suffix": "um anzufangen.",
  "tip": "Tipp:",
  "tip_iso": "erst eine ISO über die ISO-Library hochladen, dann VM mit dieser ISO erstellen.",
  "summary": {
    "total": "VMs gesamt",
    "running": "Laufend",
    "vcpu": "vCPU belegt",
    "ram": "RAM belegt"
  },
  "status": {
    "created": "Erstellt",
    "starting": "Startet…",
    "running": "Läuft",
    "stopping": "Stoppt…",
    "stopped": "Gestoppt",
    "error": "Fehler"
  },
  "actions": {
    "start": "Start",
    "console": "Konsole",
    "stop": "Stop",
    "poweroff": "Aus",
    "console_title": "VNC-Konsole im Browser öffnen",
    "stop_title": "Graceful Shutdown (ACPI)",
    "poweroff_title": "Hard Power-Off (SIGKILL)",
    "logs_title": "QEMU-Log",
    "snapshots_title": "Snapshots",
    "edit_title": "VM bearbeiten",
    "delete_title": "Löschen"
  },
  "iso": {
    "title": "ISO-Library",
    "close": "Schließen",
    "empty": "Keine ISOs vorhanden.",
    "upload": "ISO hochladen",
    "uploading": "Upload {{pct}}%"
  },
  "imports": {
    "title": "Disk-Import",
    "button": "Disk-Import",
    "empty": "Keine Import-Jobs.",
    "upload": "Disk-Image hochladen (qcow2/raw/vmdk/vdi)",
    "uploading": "Upload {{pct}}%",
    "server_path_placeholder": "Server-Pfad zu existierender Disk (Admin only, z.B. /tmp/disk.qcow2)",
    "delete_confirm": "Job \"{{id}}…\" löschen?",
    "delete_confirm_done": " (qcow2 wird mitgelöscht falls nicht von VM verwendet)"
  },
  "snapshots": {
    "loading": "Lade…",
    "empty": "Noch keine Snapshots.",
    "name_placeholder": "Snapshot-Name (z.B. before-update)",
    "desc_placeholder": "Beschreibung (optional)",
    "error_name_empty": "Name darf nicht leer sein"
  },
  "logs": {
    "no_log": "Noch keine Log-Datei — VM wurde noch nicht gestartet.",
    "empty": "Log ist leer."
  },
  "create": {
    "title": "Neue VM erstellen",
    "submit": "VM erstellen",
    "submitting": "Erstelle…",
    "cancel": "Abbrechen",
    "error_name_invalid": "Name: 1–32 Zeichen, beginnt mit Buchstabe, nur a-z A-Z 0-9 -",
    "field_node": "Ziel-Node",
    "node_hint": "Standard ist der lokale QEMU-Host. Remote-Nodes brauchen Incus + KVM.",
    "node_local": "Lokal (QEMU)",
    "field_image": "Image",
    "image_hint": "Kuratiertes Cloud-Image für die Remote-VM.",
    "remote_note": "Remote-VM: läuft dauerhaft als Incus-VM auf dem gewählten Node (Admin-only). ISO-Boot, Import und Passthrough sind auf Remote-Nodes nicht verfügbar.",
    "field_name": "Name",
    "field_name_hint": "1–32 Zeichen, beginnt mit Buchstabe, nur a-z A-Z 0-9 -",
    "field_desc": "Beschreibung (optional)",
    "field_boot_src": "Boot-Quelle",
    "field_iso": "ISO auswählen",
    "field_import_job": "Import-Job auswählen",
    "field_import_hint": "qcow2 wird in die VM verschoben, der Job verschwindet danach.",
    "field_network": "Netzwerk",
    "field_disk_interface": "Disk-Interface",
    "field_machine_type": "Machine-Type",
    "field_network_device": "Network-Device",
    "no_isos": "Keine ISOs vorhanden — erst hochladen.",
    "disk_size_from_import": "Disk-Größe kommt aus der importierten Datei.",
    "boot_iso_title": "Aus ISO booten",
    "boot_iso_desc": "Neue Disk + ISO als Boot-Medium",
    "boot_import_title": "Importierte Disk",
    "boot_import_desc": "qcow2 aus Import-Job übernehmen",
    "boot_blank_title": "Leere Disk",
    "boot_blank_desc": "Boot-loop bis Setup nachgereicht wird",
    "net_bridged_title": "Bridged (br0)",
    "net_bridged_desc": "VM bekommt DHCP-IP aus dem LAN",
    "net_isolated_title": "Isoliert",
    "net_isolated_desc": "Kein Netzwerk-Zugang",
    "disk_hint_iso": "virtio = schnellste Performance unter KVM. sata wenn das Gast-OS keine virtio-Treiber hat (z.B. Windows ohne virtio-win).",
    "disk_hint_import": "sata = kompatibel mit den meisten importierten Images. virtio falls die Quelle virtio-Treiber mitbringt.",
    "disk_virtio_title": "virtio",
    "disk_virtio_desc": "Schnell, Default",
    "disk_sata_desc": "Kompatibel, für importierte Images",
    "disk_ide_desc": "Legacy, Notnagel",
    "machine_hint": "q35 = modernes ICH9-Chipset (Default). pc = i440FX, kompatibel mit FreeBSD-ZFS-Boot, Windows XP, alte Linux, VirtualBox-Imports.",
    "machine_q35_desc": "Modern, Default",
    "machine_pc_desc": "Kompatibel, FreeBSD/XP/alt",
    "netdev_hint": "virtio-net-pci = schnell (Default). e1000 = Intel-NIC, in fast jedem Gast-OS unterstützt — für Imports ohne virtio-Treiber.",
    "netdev_virtio_desc": "Schnell, Default",
    "netdev_e1000_desc": "Intel-Treiber, kompatibel"
  },
  "edit": {
    "error_name_invalid": "Name: 1-32 Zeichen, beginnt mit Buchstabe, nur a-z A-Z 0-9 -",
    "error": "Fehler",
    "field_name": "Name",
    "field_desc": "Beschreibung",
    "field_cpu": "CPU-Kerne",
    "field_ram": "RAM (MB)",
    "field_boot_iso": "Boot-ISO (leer = keine ISO eingelegt)",
    "field_disk_interface": "Disk-Interface",
    "field_machine_type": "Machine-Type",
    "field_network_device": "Network-Device",
    "disk_virtio_label": "virtio (schnell, Default)",
    "disk_sata_label": "sata (kompatibel, für importierte Images)",
    "disk_ide_label": "ide (Legacy)"
  }
}
